import Cookies from 'js-cookie';
import axios from 'axios';

export async function fetchAndGetCSRFToken() {
  await axios.get('/api/csrf/', { withCredentials: true });
  return Cookies.get('csrftoken');
}

export function getCSRFToken() {
  return Cookies.get('csrftoken');
}
